import LocalizedStrings from 'react-localization';
import GeneralConfig from '../config/general';
import hungarianTranslations from './translations.hu.js';
import englishTranslations from './translations.en.js';
import deutschTranslations from './translations.de.js';

/**
 * Get URL, search for language prefix. If not set, return default language.
 *
 * @returns string
 */
const checkLanguagePrefix = (): string => {
	const languages = GeneralConfig.locales;
	
	//Set active language based on URL, if no param set, use default
	let language = GeneralConfig.defaultLocale;
	const url = window.location.href;
	for(let i=0; i < languages.length; i++) {
		if(url.includes('/'+languages[i].code+'/')) {
			language = languages[i].code;
			break;
		}
	}

	return language;
};

/**
 * Check URL prefix, update language if needed. Called when a page renders with UrlTracker HOC.
 */
const onNavigate = (): void => {
	//Determine current language
	let language: string = checkLanguagePrefix();

	if(language !== localizedStrings.getLanguage()) {
		localizedStrings.setLanguage(language);
	}
};

//Determine current language
let language: string = checkLanguagePrefix();

//Init
let localizedStrings = new LocalizedStrings({
	hu: hungarianTranslations,
	en: englishTranslations,
	de: deutschTranslations,
});

//Set active language
const localePreference = localStorage.getItem('locale');
localizedStrings.setLanguage(localePreference ?? language);

export let translations = localizedStrings;
export default { onNavigate, translations };